// Pause other videos when one starts playing
document.addEventListener('DOMContentLoaded', function () {
  const videos = document.querySelectorAll('video[controls]')
  videos.forEach((video) => {
    video.addEventListener('play', () => {
      videos.forEach((other) => {
        if (other !== video) other.pause()
      })
    })
  })
})
